import { WebhookRecord, webhookFromJSON } from "common/records/Webhook";
import { RootActions, RootState } from "common/reducers";
import { Map, Record, getIn } from "immutable";
import { WebhookEventRecord, webhookEventfromJSON } from "common/records/WebhookEvent";
import { reset } from "common/reducers/Utils";
import { reducer as idsManagementReducer } from "common/reducers/idsManagement.reducer";
import { IdsManagementActions } from "common/reducers/idsManagement.actions";
import {
  RECEIVE_WEBHOOK,
  RECEIVE_WEBHOOKS,
  RECEIVE_WEBHOOK_EVENT,
  RECEIVE_WEBHOOK_EVENTS,
  REMOVE_WEBHOOK,
  RESET_WEBHOOK,
  WebhookActions,
} from "common/reducers/webhook.actions";

export const WebhookStateRecord = Record({
  byId: Map<string, WebhookRecord>(),
  eventsById: Map<string, WebhookEventRecord>(),
  lastSavedById: Map<string, WebhookRecord>(),
});

export const initialState = WebhookStateRecord();

export type WebhookState = typeof initialState;

export const model = "webhooks";
export const eventsModel = "webhook_events";
export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_WEBHOOK:
      const webhookRecord = webhookFromJSON(action.payload);
      return state
        .setIn([model, "byId", action.payload.id], webhookRecord)
        .setIn([model, "lastSavedById", action.payload.id], webhookRecord);

    case RECEIVE_WEBHOOK_EVENT:
      const webhookEventRecord = webhookEventfromJSON(action.payload);
      return state.setIn([model, "eventsById", action.payload.id], webhookEventRecord);

    case RESET_WEBHOOK: {
      const { webhookId } = action.payload;
      return reset(state, model, webhookId) as RootState;
    }

    case RECEIVE_WEBHOOKS:
      action.payload.webhooks.forEach((webhook) => {
        state = reducer(state, WebhookActions.receiveWebhook(webhook));
      });
      return state;

    case RECEIVE_WEBHOOK_EVENTS:
      action.payload.webhook_events.forEach((webhook) => {
        state = reducer(state, WebhookActions.receiveWebhookEvent(webhook));
      });
      return state;

    case REMOVE_WEBHOOK:
      state = idsManagementReducer(state, IdsManagementActions.removeId(action.payload.webhookId, "webhooks"));
      return state.deleteIn(["webhooks", "byId", action.payload.webhookId]);
    default:
      return state;
  }
};
